import request from '@/utils/request';

/**
 * 获取作品章节目录树
 */
export function getChapterTree(projectId) {
  return request({
    url: `/front/chapter/tree/${projectId}`,
    method: 'get'
  });
}

/**
 * 获取章节详情（含正文）
 */
export function getChapter(id) {
  return request({
    url: `/front/chapter/${id}`,
    method: 'get'
  });
}

/**
 * 新增章节
 * @param {object} data - { projectId, parentId, title }
 */
export function createChapter(data) {
  return request({
    url: '/front/chapter',
    method: 'post',
    data
  });
}

/**
 * 批量在指定卷下创建章节
 * @param {number} projectId
 * @param {number} parentId - 卷的 ID
 * @param {Array<{title: string, summary: string}>} chapters
 */
export function batchCreateChapters(projectId, parentId, chapters) {
  return request({
    url: '/front/chapter/batch',
    method: 'post',
    data: { projectId, parentId, chapters }
  });
}

/**
 * 更新章节（标题/正文/排序）
 */
export function updateChapter(id, data) {
  return request({
    url: `/front/chapter/${id}`,
    method: 'put',
    data
  });
}

/**
 * 删除章节（卷会级联删除子章节）
 */
export function deleteChapter(id) {
  return request({
    url: `/front/chapter/${id}`,
    method: 'delete'
  });
}
